export type PopperOffsetModifier = { name: "offset"; options: { offset: [number, number] } };

/**
 * A held-open menu (see decks/materialsCreateDeck.ts's `heldMenuWidth`) can extend past its own
 * anchor button on the very side the tour's own card sits — the card's ordinary 12px gap is nowhere
 * near enough to clear it, so the two overlap. Pushing the card's popper `distance` out by that
 * overhang (plus the ordinary 12px) clears it regardless of which side the card places to: popper's
 * offset "distance" is always the gap along the placement's main axis, whichever direction that is.
 * Pure arithmetic — the anchor's measured width is the caller's job (WelcomeTour.vue reads the real,
 * laid-out DOM at start() time), so this stays unit-testable without touching the DOM itself.
 */
export function heldMenuOffsetModifiers(anchorWidth: number, heldMenuWidth: number | undefined): PopperOffsetModifier[] {
  if (heldMenuWidth === undefined) return [];
  const distance = Math.max(0, heldMenuWidth - anchorWidth) + 12;
  return [{ name: "offset", options: { offset: [0, distance] } }];
}
